<template>
  <section class="px-6 py-6 space-y-8 min-h-screen font-light select-none transition-colors duration-200"
    :class="isDark ? 'bg-zinc-950 text-zinc-400' : 'bg-white text-zinc-600'">

    <div class="flex justify-between items-center border-b pb-5 transition-colors duration-200"
      :class="isDark ? 'border-zinc-900/60' : 'border-zinc-100'">
      <div class="space-y-1 text-left">
        <h1 class="text-xl font-normal tracking-tight transition-colors duration-200"
          :class="isDark ? 'text-white' : 'text-zinc-900'">
          Vue d'ensemble
        </h1>
        <p class="text-xs font-light transition-colors duration-200"
          :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
          Indicateurs de performance opérationnelle et analytique de votre établissement.
        </p>
      </div>
      <div class="flex gap-4 items-center">
        <div class="px-4 py-2 border rounded-xl flex items-center gap-2 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900/40 border-zinc-900'
            : 'bg-zinc-50 border-zinc-100'">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          <span class="text-xs font-mono tracking-wide transition-colors duration-200"
            :class="isDark ? 'text-zinc-400' : 'text-zinc-500'">
            {{ currentTime }}
          </span>
        </div>
      </div>
    </div>

    <!-- Progression du profil -->
    <ProfileCompletionProgress />

    <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">

      <div class="rounded-2xl border p-5 flex items-center gap-4 transition-all duration-300 relative overflow-hidden group"
        :class="isDark
          ? 'bg-zinc-900/20 border-zinc-900/80 hover:border-zinc-800'
          : 'bg-zinc-50/50 border-zinc-100 hover:border-zinc-200/80 hover:bg-zinc-50/80'">
        <div class="flex items-center justify-center w-11 h-11 rounded-xl border shrink-0 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900 text-[#D5CCBC] border-zinc-800'
            : 'bg-white text-zinc-800 border-zinc-200/60 shadow-sm'">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.879c1.003 1.003 2.63 1.003 3.632 0l.118-.118a3.625 3.625 0 000-5.127l-.118-.119a3.625 3.625 0 010-5.127l.118-.118c1.003-1.003 2.63-1.003 3.632 0M3 12h18" />
          </svg>
        </div>
        <div class="flex flex-col text-left min-w-0">
          <span class="text-[10px] uppercase tracking-widest font-medium transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
            Revenu Mensuel
          </span>
          <span class="text-xl font-normal tracking-tight mt-0.5 truncate transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-zinc-900'">
            {{ caTotal }} €
          </span>
        </div>
      </div>

      <div class="rounded-2xl border p-5 flex items-center gap-4 transition-all duration-300 relative overflow-hidden group"
        :class="isDark
          ? 'bg-zinc-900/20 border-zinc-900/80 hover:border-zinc-800'
          : 'bg-zinc-50/50 border-zinc-100 hover:border-zinc-200/80 hover:bg-zinc-50/80'">
        <div class="flex items-center justify-center w-11 h-11 rounded-xl border shrink-0 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900 text-[#D5CCBC] border-zinc-800'
            : 'bg-white text-zinc-800 border-zinc-200/60 shadow-sm'">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
        </div>
        <div class="flex flex-col text-left min-w-0">
          <span class="text-[10px] uppercase tracking-widest font-medium transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
            Fichier Clients
          </span>
          <span class="text-xl font-normal tracking-tight mt-0.5 truncate transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-zinc-900'">
            {{ devisAcceptes }}
          </span>
        </div>
      </div>

      <div class="rounded-2xl border p-5 flex items-center gap-4 transition-all duration-300 relative overflow-hidden group"
        :class="isDark
          ? 'bg-zinc-900/20 border-zinc-900/80 hover:border-zinc-800'
          : 'bg-zinc-50/50 border-zinc-100 hover:border-zinc-200/80 hover:bg-zinc-50/80'">
        <div class="flex items-center justify-center w-11 h-11 rounded-xl border shrink-0 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900 text-[#D5CCBC] border-zinc-800'
            : 'bg-white text-zinc-800 border-zinc-200/60 shadow-sm'">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zM14.25 15h.008v.008H14.25V15zm0 2.25h.008v.008H14.25v-.008zM16.5 15h.008v.008H16.5V15zm0 2.25h.008v.008H16.5v-.008z" />
          </svg>
        </div>
        <div class="flex flex-col text-left min-w-0">
          <span class="text-[10px] uppercase tracking-widest font-medium transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
            Taux de Remplissage
          </span>
          <span class="text-xl font-normal tracking-tight mt-0.5 truncate transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-zinc-900'">
            {{ nombreAgences }} %
          </span>
        </div>
      </div>

      <div class="rounded-2xl border p-5 flex items-center gap-4 transition-all duration-300 relative overflow-hidden group"
        :class="isDark
          ? 'bg-zinc-900/20 border-zinc-900/80 hover:border-zinc-800'
          : 'bg-zinc-50/50 border-zinc-100 hover:border-zinc-200/80 hover:bg-zinc-50/80'">
        <div class="flex items-center justify-center w-11 h-11 rounded-xl border shrink-0 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900 text-[#D5CCBC] border-zinc-800'
            : 'bg-white text-zinc-800 border-zinc-200/60 shadow-sm'">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="flex flex-col text-left min-w-0">
          <span class="text-[10px] uppercase tracking-widest font-medium transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
            Actes Programmés
          </span>
          <span class="text-xl font-normal tracking-tight mt-0.5 truncate transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-zinc-900'">
            {{ Math.round(tauxConversion) }}
          </span>
        </div>
      </div>

    </div>

    <div class="grid gap-6" :class="isAdmin ? 'lg:grid-cols-3' : 'lg:grid-cols-1'">
      <div class="border rounded-2xl p-4 transition-colors duration-200"
        :class="[
          isAdmin ? 'lg:col-span-2' : 'lg:col-span-1',
          isDark
            ? 'border-zinc-900 bg-zinc-900/10 shadow-xl shadow-black/20'
            : 'border-zinc-100 bg-white shadow-sm shadow-zinc-100/50'
        ]">
        <CalendarWeek />
      </div>

      <div v-if="isAdmin" class="lg:col-span-1">
        <BusinessHours />
      </div>
    </div>

    <div class="w-full border rounded-2xl p-5 transition-colors duration-200"
      :class="isDark
        ? 'bg-zinc-900/10 border-zinc-900 shadow-xl shadow-black/20'
        : 'bg-white border-zinc-100 shadow-sm shadow-zinc-100/50'">
      <ResponseRateHistory />
    </div>

  </section>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { useTheme } from '@/composables/useTheme';
import { usePermissions } from '@/composables/usePermissions';
import ResponseRateHistory from "../components/Graphs/ResponseRateHistory.vue";
import CalendarWeek from "@/components/CalendarWeek.vue";
import BusinessHours from "@/components/BusinessHours.vue";
import ProfileCompletionProgress from "@/components/ProfileCompletionProgress.vue";
import api from '@/api';

// === Thème ===
const { isDark } = useTheme();
const { isAdmin } = usePermissions();

// === Données dynamiques depuis le backend ===
const caTotal = ref(0);
const tauxConversion = ref(0);
const nombreAgences = ref(0);
const devisAcceptes = ref(0);
const isLoading = ref(true);

// === Heure dynamique ===
const currentTime = ref("");

const updateTime = () => {
  const now = new Date();
  currentTime.value = now.toLocaleTimeString("fr-FR", {
    hour12: false,
  });
};

// Récupérer les statistiques du dashboard
const fetchDashboardStats = async () => {
  try {
    isLoading.value = true;
    const response = await api.analytics.getDashboardStats();
    console.log(" Dashboard stats : " ,response.data)
    if (response.data) {
      caTotal.value = response.data.caTotal || 0;
      devisAcceptes.value = response.data.nombreClients || 0;
      nombreAgences.value = response.data.tauxRemplissage || 0;
      tauxConversion.value = response.data.actesProgrammes || 0;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des statistiques:', error);
    toast.error('Erreur lors du chargement des statistiques', {
      position: 'top-right',
      autoClose: 3000
    });

    // Initialiser à 0 en cas d'erreur
    caTotal.value = 0;
    tauxConversion.value = 0;
    nombreAgences.value = 0;
    devisAcceptes.value = 0;
  } finally {
    isLoading.value = false;
  }
};

let intervalId;

// === Lifecycle ===
onMounted(() => {
  updateTime();
  intervalId = setInterval(updateTime, 1000);
  fetchDashboardStats();
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>
